import CalendarIcon from 'components/icons/calendarThin';
import { IconContainer } from './styled';

export const ColorIcon = ({ color }: { color: string }) => (
    <IconContainer color={color}>
        <CalendarIcon />
    </IconContainer>
);
